import { css } from "@emotion/react";

export const ArrowButtonStyles = ({ arrowButton }) => css`
  padding: 0 0.75rem;
  justify-content: space-between;
  color: ${arrowButton.text.color} !important;
`;
